import { APIResponse } from '@pwc/pwc-deals-web-common';
import { ContentServiceHttpClient } from '../../common/services/httpClient';
import { PerformanceTestResults } from './PerformanceTestTypes';

export const runPerformanceTest = async (
  projectId: number | string,
  fileName: string
): Promise<{ results: PerformanceTestResults }> => {
  const { data } = (await ContentServiceHttpClient.post(
    `/projects/${projectId}/performancetest`,
    { fileName }
  )) as APIResponse<{ results: PerformanceTestResults }>;

  return data || { results: [] };
};
